module.exports = __webpack_public_path__ + "static/media/sweeney_dimaggio_white_dyer_delema.a514c0f5.jpg";